// extracted by mini-css-extract-plugin
export default {"Image":"Image_Image__KgX69","loaded":"Image_loaded__NeadZ","background":"Image_background__nqwRo"};